import { useGetOwfReferralCode } from "./useGetOwfReferralCode";

export const useShouldShowOwFR2R = () => {
  const maybeOwfReferralCode = useGetOwfReferralCode();
  const hasOwfReferralCode: boolean = typeof maybeOwfReferralCode === "string";

  const referralCode: string | undefined = hasOwfReferralCode
    ? (maybeOwfReferralCode as string)
    : undefined;
  const shouldShowOwFR2R = !!referralCode;

  return { shouldShowOwFR2R, referralCode };
};
